module.exports = __webpack_public_path__ + "img/Eduzz-11-pt.08362650.png";